/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FlexLayout from '../../../components/common/FlexLayout';
import IconButton from '../../../components/common/IconButton';
import ActionPanel from '../../../components/Controller/ActionPanel';
import PopupOverlay from '../../../components/common/PopupOverlay';
import { navItems } from '../../../utils/staticData';
import { useHistory, useLocation } from 'react-router-dom';
import { alertWrapper } from '../../../utils/alertWrapper';

const ProductSelector = ({
  activeTab,
  openAlertDialog,
  isConfigSaved,
  setIsDataReady,
  setIsLoading,
  setSelectedCategory,
  getAccessoryVariantData,
  getAllAccessoryTypeDataOnTabClick
}) => {
  const location = useLocation();
  const [shouldOpen, setShouldOpen] = useState(true);

  const onModelClose = () => {
    setShouldOpen(false);
  };

  const { push } = useHistory();

  const onNavChange = value => {
    setIsDataReady(false);

    switch (value) {
      case 0:
        setIsLoading(true);
        push('/jackets');
        setShouldOpen(false);
        break;
      case 1:
        push('/helmet');
        setShouldOpen(false);
        break;
      case 2:
        setIsLoading(true);
        push('/tshirt');
        setShouldOpen(false);
        break;
      default:
        push('/helmet');
        setShouldOpen(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'helmet') {
      getAllAccessoryTypeDataOnTabClick('helmet');
      setSelectedCategory('helmetType');
    } else if (activeTab === 'tshirt') {
      getAllAccessoryTypeDataOnTabClick('tshirt');
      getAccessoryVariantData('TShirt');
    } else if (activeTab === 'jacket') {
      getAllAccessoryTypeDataOnTabClick('jacket');
    } else getAllAccessoryTypeDataOnTabClick('helmet');
  }, [activeTab]);

  return (
    <PopupOverlay isOpen={shouldOpen} style={{ zIndex: 999999999999 }}>
      <div className="type-selector_box">
        <ActionPanel
          label="Choose a Product"
          isCloseButtonHidden
          onCloseButtonClick={onModelClose}
        >
          <FlexLayout flexDirection="row" justifyContent="space-evenly">
            {navItems.map((option, i) => (
              <div key={i} className="type-selector_option">
                <IconButton
                  backgroundColor="#000"
                  iconColor="#fff"
                  label={option.label}
                  icon={option.icon}
                  onClick={() => onNavChange(i)}
                />
              </div>
            ))}
          </FlexLayout>
        </ActionPanel>
      </div>
    </PopupOverlay>
  );
};

ProductSelector.propTypes = {
  setSelectedCategory: PropTypes.func,
  selectedCategory: PropTypes.string,
  variantData: PropTypes.array,
  getAccessoryVariantData: PropTypes.func,
  isDataReady: PropTypes.bool,
  setIsDataReady: PropTypes.func,
  setIsLoading: PropTypes.func,
  selectedVariant: PropTypes.string,
  openAlertDialog: PropTypes.func,
  isConfigSaved: PropTypes.bool
};

export default ProductSelector;
